import { RocheUIImageLoading, RocheUIImageRatio, RocheUIStageHome } from '@repo/roche-ui';
import React, { FC } from 'react';
import { blokToComponent } from '../../helpers/blok-to-component';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { getImageOrVideo } from '../../helpers/slotted-to-image';
import { SlottedImageDataType } from '../../helpers/slotted-to-image/types';
import { RocheStageHomeTeaserProps } from './roche-stage-home-teaser';

type RocheStageHomeProps = BlokToComponentProps<{
  statement: string;
  slotted_image: SlottedImageDataType[];
  slotted_teaser: RocheStageHomeTeaserProps[];
}>;

export const RocheStageHome: FC<RocheStageHomeProps> = ({ blok, slot, getComponent }) => {
  if (!blok) {
    return null;
  }
  const teasers = blok.slotted_teaser?.map((button) =>
    blokToComponent({ getComponent, blok: button, hasMarginTop: false } as BlokToComponentProps<any>, 'button'),
  );
  return (
    <RocheUIStageHome
      statement={blok.statement}
      // since the stage-home is always at the top, we want to load the image eagerly
      Image={getImageOrVideo(blok?.slotted_image, RocheUIImageRatio.HD, false, RocheUIImageLoading.EAGER)}
      slot={slot}
    >
      {teasers}
    </RocheUIStageHome>
  );
};
